(function() {
  var StepController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  StepController = App.loadClass('grower::Angular/Data/PlantingRx/StepController');

  exports.ProductPlanterController = (function(superClass) {
    extend(ProductPlanterController, superClass);

    function ProductPlanterController(scope, transitions, rxLayer, q, seedCompanies, products) {
      var loadBrandsAndTreatments, row;
      this.scope = scope;
      this.transitions = transitions;
      this.rxLayer = rxLayer;
      this.q = q;
      this.seedCompanies = seedCompanies;
      this.products = products;
      this.populateRepos = bind(this.populateRepos, this);
      this.disableRow = bind(this.disableRow, this);
      this.selectBrand = bind(this.selectBrand, this);
      this.selectCompany = bind(this.selectCompany, this);
      this.setDefaultTreatment = bind(this.setDefaultTreatment, this);
      this.loadBrandTreatments = bind(this.loadBrandTreatments, this);
      this.loadCompanyBrands = bind(this.loadCompanyBrands, this);
      this.addRefugeRow = bind(this.addRefugeRow, this);
      ProductPlanterController.__super__.constructor.call(this, this.scope, this.transitions);
      if (this.scope.aborted) {
        return;
      }
      this.scope.$parent.show_fullpage = true;
      this.scope.disableRow = this.disableRow;
      this.scope.selectCompany = this.selectCompany;
      this.scope.selectBrand = this.selectBrand;
      this.scope.loadCompanyBrands = this.loadCompanyBrands;
      this.scope.loadBrandTreatments = this.loadBrandTreatments;
      this.scope.$watch('productPlanterForm.$valid', (function(_this) {
        return function(value) {
          return _this.scope.$parent.setValidity(value);
        };
      })(this));
      this.populateRepos();
      loadBrandsAndTreatments = (function(_this) {
        return function() {
          var i, len, ref, results, row;
          ref = _this.scope.rx.planting_selections;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            row = ref[i];
            if (row.company != null) {
              _this.loadCompanyBrands(row, row.company);
            }
            if (row.brand != null) {
              results.push(_this.loadBrandTreatments(row, row.brand));
            } else {
              results.push(void 0);
            }
          }
          return results;
        };
      })(this);
      loadBrandsAndTreatments();
      this.scope.$on('rx:loaded', (function(_this) {
        return function() {
          return loadBrandsAndTreatments();
        };
      })(this));
      this.addRefugeRow();
      if (this.scope.rx.refuge != null) {
        row = this.scope.rx.refuge;
        if (row.company != null) {
          this.loadCompanyBrands(row, row.company);
        }
        if (row.brand != null) {
          this.loadBrandTreatments(row, row.brand);
        }
      }
    }


    /*
     * Add the default refuge row. If there's no refuge specified,
     * we add this disabled row, so people always have the option of
     * enabling and adding a refuge.
     */

    ProductPlanterController.prototype.addRefugeRow = function() {
      if (this.scope.rx.refuge == null) {
        return this.scope.rx.refuge = {
          name: 'Refuge',
          company: null,
          brand: null,
          treatment: null,
          refuge: true,
          active: false
        };
      }
    };


    /*
     * Load brands for a given company into a given row
     */

    ProductPlanterController.prototype.loadCompanyBrands = function(row, company) {
      var selected;
      selected = this.rxLayer.selectedHybridIds();
      return this.products.bySeedCompany(company.id, this.scope.rx.fields_id, this.scope.rx.crops_id, selected).then((function(_this) {
        return function(response) {
          return row.products = response.data.data;
        };
      })(this));
    };


    /*
     * When the user selects a brand for a row,
     * dynamically load the treatments for that brand
     */

    ProductPlanterController.prototype.loadBrandTreatments = function(row, brand) {
      return this.products.treatments(brand.id, this.scope.rx.spp_id).then((function(_this) {
        return function(response) {
          row.treatments = response.data.data;
          return _this.setDefaultTreatment(row);
        };
      })(this));
    };


    /*
     * Handles setting the default treatment for a row if there is one
     * and it's in the treatment list
     */

    ProductPlanterController.prototype.setDefaultTreatment = function(row) {
      var found_treatment, i, len, ref, tmt;
      found_treatment = null;
      if ((row.brand.default_treatment_id != null) || (row.brand.secondary_treatment_id != null)) {
        ref = row.treatments;
        for (i = 0, len = ref.length; i < len; i++) {
          tmt = ref[i];
          if (tmt.id === row.brand.secondary_treatment_id) {
            found_treatment = tmt;
          }
          if (tmt.id === row.brand.default_treatment_id) {
            found_treatment = tmt;
            break;
          }
        }
        return row.treatment = found_treatment;
      }
    };


    /*
     * When the user selects a seed company for a row,
     * unset the selected brand and treatment, and call
     * the method to load the brands for this company
     */

    ProductPlanterController.prototype.selectCompany = function(row, company) {
      row.brand = null;
      row.treatment = null;
      return this.loadCompanyBrands(row, company);
    };


    /*
     * When the user selects a brand, handle refuge requirement
     */

    ProductPlanterController.prototype.selectBrand = function(row, brand) {
      this.loadBrandTreatments(row, brand);
      if (!row.primary) {

      }
    };


    /*
     * If we want to remove the low yield product or the refuge, we can disable
     * the row, clearing selected values and setting it to inactive
     */

    ProductPlanterController.prototype.disableRow = function(row) {
      row.company = null;
      row.brand = null;
      row.treatment = null;
      row.brands = null;
      row.treatments = null;
      return row.active = false;
    };


    /*
     * Query repositories for all relevant information.
     * If the data is already set for a give item, we probably
     * don't need to re-load it.
     *
     * The scope.repos variable *references* the parent (SidebarController)
     * repos variable, so that means that the repos will live on after
     * this step is passed / destroyed. This means that if the user
     * comes back to this step, we won't have to re-query.
     */

    ProductPlanterController.prototype.populateRepos = function() {
      var p, promises;
      this.scope.$emit('planting-rx:step-loading');
      promises = [];
      if (this.scope.repos.seed_companies == null) {
        p = this.seedCompanies.all({
          crops_id: this.scope.rx.crops_id
        });
        p.then((function(_this) {
          return function(response) {
            return _this.scope.repos.seed_companies = response.data.data;
          };
        })(this));
        promises.push(p);
      }
      return this.q.all(promises).then((function(_this) {
        return function() {
          return _this.scope.$emit('planting-rx:step-ready');
        };
      })(this));
    };

    return ProductPlanterController;

  })(StepController);

}).call(this);
